<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState === ImportStepState.Available, 'material-icons-outlined': stepState === ImportStepState.Completed}">{{ stepState ===
                ImportStepState.Completed ? 'check' : '1' }}</span></div>
        <h4>Comparison</h4>
    </div>

    <ng-container *ngIf="isActive()">
        <div *ngIf="showHint" class="hint-block">
            <div class="wrap-text">
                <p class="body-2">
                    The source file includes these valid import tags: period, visit to bookings, bookings, length of stay.
                </p>
                <p class="body-2">
                    Select here the time periods or categories to compare variance, such as "Pre vs. Post", "2018 vs. 2019", "A/B Test", "Budget vs. Actuals", etc.
                </p>
            </div>
            <a (click)="showHint = false" class="btn-close material-icons-outlined">close</a>
        </div>
        <div *ngIf="dataLoaded">
            <div class="body-1 mb-8">Select the column including the two periods or groups to compare</div>
            <div #tableContainer class="table-container column-border table-big">
                <!-- Header row -->
                <div class="row header">
                    <div *ngFor="let col of columns" class="cell" (click)="selectColumn(col)" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <div class="subtitle-2">{{col.name}}</div>
                        <span class="body-2">{{ displayRoughNum(col.uniqueValues) }}</span>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length">
                            {{col.someVals[0]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                            {{col.someVals[1]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                            {{col.someVals[2]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                            {{col.someVals[3]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                            {{col.someVals[4]}}
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="dataLoaded" class="select-range">
            <div class="body-1 mb-8">Analyze variance between</div>
            <div class="select-controls">
                <mat-form-field appearance="fill">
                    <mat-select [(value)]="selectedOldControlValue">
                        <mat-option *ngFor="let v of selectedColumn.usefulVals" [value]="v" (onSelectionChange)="oldControlValChanged($event)">
                            {{v}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="divider"> – </span>
                <mat-form-field appearance="fill">
                    <mat-select [(value)]="selectedNewControlValue">
                        <mat-option *ngFor="let v of selectedColumn.usefulVals" [value]="v" (onSelectionChange)="newControlValChanged($event)">
                            {{v}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>

    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div *ngIf="dataLoaded" class="d-flex">
            <div class="info-block">
                <span class="body-1">Column</span>
                <span class="body-1 text-900">{{selectedColumn.name}}</span>
            </div>
            <div class="info-block">
                <span class="body-1">Analyze variance between</span>
                <span class="body-1 text-900">{{selectedOldControlValue}} - {{selectedNewControlValue}}</span>
            </div>
        </div>
        <div>
            <button (click)="editClick()" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
